import { render, staticRenderFns } from "./DesignerForm.vue?vue&type=template&id=5ed2adf6&"
import script from "./DesignerForm.vue?vue&type=script&lang=js&"
export * from "./DesignerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports